module.exports = __webpack_public_path__ + "a883ccc66e6662e8b62af42880aab733.svg";